import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-monthly-sale-abstract',
  templateUrl: './monthly-sale-abstract.component.html',
  styleUrls: ['./monthly-sale-abstract.component.scss']
})
export class MonthlySaleAbstractComponent implements OnInit {

  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  month_list_for_last_12_months: any = [];
  selected_month: any = null;
  is_document_available: boolean = true;
  is_data_available: boolean = true;
  total_sale_details: any;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title = null;
  selected_month_for_report: any = null;
  pdf_data: any;
  document_file: any = null;

  constructor(private httpService: HttpService,  private global: GlobalService, private dom: DomSanitizer) {
    let today = new Date();
    this.title = this.global._active_display_name;
    today.setDate(1);
    let data_dict = {
      'month_in_string': this.monthNames[today.getMonth()],
      'month_in_integer': today.getMonth(),
      'year': today.getFullYear()
    }
    this.month_list_for_last_12_months.push(data_dict);
    for (let i = 0; i <= 11; i++) {
      today.setMonth(today.getMonth() - 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth(),
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    console.log(this.month_list_for_last_12_months);
   }


   getClicked(){
    let data_dict = {
      'month': this.selected_month_for_report,
        }
    console.log(data_dict);
    this.httpService.monthlyProductSaleAbstractReport(data_dict).subscribe((data) => {
      console.log(data);
      if(data == false){
        alert('Data not available in this months')
        return false
      }
      this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
   }

   downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  downloadClickedFoExcel() {
    const linkSource = 'data:application/xlsx;base64,' + this.document_file['excel'];
    // let w = window.open(linkSource);
    // w.print();
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['excel_file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
  }

}
